import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingMedicaidService from "@app/overviews/network-benchmarking-dashboard/benchmarkingMedicaidService";
import { MedicaidPrimaryFilterOptionUpdates } from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/shared/MedicaidPrimaryFilterOptionUpdates";

export interface MedicaidPrimaryFilterOptionUpdatesResult {
  isLoading: boolean;
  primaryFilterUpdates: MedicaidPrimaryFilterOptionUpdates | undefined;
}

export const MEDICAID_PRIMARY_FILTER_UPDATES_QUERY_KEY_PREFIX = "medicaid-primary-filter-updates";

export const useMedicaidPrimaryFilterOptionUpdates = (
  clientId: number | undefined,
  stateId: number | undefined,
  programKey: string | null,
  enabled: boolean
): MedicaidPrimaryFilterOptionUpdatesResult => {
  const benchmarkingMedicaidService = useMemo(() => new BenchmarkingMedicaidService(), []);

  const queryResult = useQuery<MedicaidPrimaryFilterOptionUpdates>({
    enabled: enabled && !!stateId && !!programKey,
    queryFn: ({ signal }) => benchmarkingMedicaidService.getPrimaryFilterOptionUpdates(stateId as number, programKey as string, signal),
    queryKey: [MEDICAID_PRIMARY_FILTER_UPDATES_QUERY_KEY_PREFIX, clientId, stateId, programKey],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    primaryFilterUpdates: queryResult.data,
  };
}

export default useMedicaidPrimaryFilterOptionUpdates;
